export const createImgStyles = (nonstandardImg) => ({
  marginTop: nonstandardImg ? '30px' : '0',
  width: '100%',
  maxWidth: nonstandardImg ? `${nonstandardImg}px` : '520px',
  position: 'relative',
});

const styles = {
  top: {
    display: {
      xs: 'flex',
      md: 'block',
    },
    lineHeight: {
      md: 0,
    },
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    '& *': {
      order: 1,
    },
  },
  type: {
    opacity: 0.5,
    order: 0,
    marginTop: {
      md: '16px',
    },
  },
  title: {
    color: 'kit.text.h',
    marginTop: '32px',
    textTransform: 'uppercase',
  },
  title_dark: {
    color: 'kit.text.accent',
  },
  list: {
    paddingBottom: {
      xs: '26px',
      lg: '28px',
    },
  },
  features: {
    listStyle: 'none',
    padding: 0,
    mt: 4,
    mb: 0,
    display: 'flex',
    columnGap: 2,
    rowGap: 1,
    flexWrap: 'wrap',
  },
  featureItem: {
    display: 'flex',
    alignItems: 'center',

    '&:last-child': {
      marginRight: 0,
    },
  },
  buttonsBlock: {
    mt: 4,
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    maxWidth: 492,
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
    alignItems: {
      sm: 'center',
      xs: 'flex-start',
    },
  },
  button: {
    // minWidth: '230px',
    '&:last-child': {
      marginTop: {
        xs: '16px',
        md: '0',
      },
      marginRight: {
        xs: '0',
      },
    },
  },
  imageBlock: {
    display: {
      xs: 'none',
      md: 'block',
    },
  },
  image: {
    width: '100%',
    height: 'auto',
  },
  duration: {
    color: 'kit.text.mainInverse',
    position: 'absolute',
    left: '7%',
    top: '45%',
    transform: 'translateY(-50%)',
    lineHeight: 1,
  },
  number: {
    fontFamily: 'RF Rostin',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '51.54px',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  currency: {
    fontSize: '13.54px',
    lineHeight: '21px',
    textAlign: 'center',
    letterSpacing: '0.01em',
    textTransform: 'uppercase',
  },
};

export default styles;
